import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'SCENARIOS',
    itemActionName: 'SCENARIO',
});
